import { render, staticRenderFns } from "./HeaderNote.pug?vue&type=template&id=cfb0ebb6&scoped=true&lang=pug&"
import script from "./HeaderNote.vue?vue&type=script&lang=js&"
export * from "./HeaderNote.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNote.scss?vue&type=style&index=0&id=cfb0ebb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb0ebb6",
  null
  
)

export default component.exports